export default "__VITE_ASSET__DKDK1icx__"